import React from "react";
import { observer } from "mobx-react";

import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import { SwiperWrapper } from "@components-shared/mobile/swiper/SwiperWrapper";
import { LiveStatisticsButton } from "@features/offer/shared/event/LiveStatisticsButton";
import { StreaksStatisticsButton } from "@features/offer/shared/event/StreaksStatisticsButton";
import { FullStatisticsButton } from "@features/offer/shared/event/FullStatisticsButton";
import { SwiperType } from "@components-shared/mobile/swiper/SwiperType";
import { EventInsightsButton } from "@features/offer/shared/event/EventInsightsButton";
import { PlayerStatisticsButton } from "@features/offer/shared/event/PlayerStatisticsButton";
import { TeamStandingsButton } from "@features/offer/shared/event/TeamStandingsButton";
import { TeamLineupsButton } from "@features/offer/shared/event/TeamLineupsButton";

export default observer(function EventStatisticsHeaderPills({
	store,
}: {
	store: EventViewStore | AdditionalOfferViewStore;
}) {
	const {
		sportStatisticsStore,
		playerStatisticsStore, 
		teamLineupsStore,
		teamStandingsStatsStore,
	} = store;

	const statisticsPills = (function () {
		const pills: {
			type: StatisticsGroups;
			Component: typeof PlayerStatisticsButton;
			props?: any;
		}[] = [];

        if (sportStatisticsStore.isMatchStatsAvailable) {
			pills.push({
				type: StatisticsGroups.LiveStats,
				Component: LiveStatisticsButton,
			});
		}

		if (sportStatisticsStore.isStreakStatAvailable) {
			pills.push({
				type: StatisticsGroups.StreakStats,
				Component: StreaksStatisticsButton,
			});
		}

        if (teamLineupsStore.isTeamLineupsAvailable) {
            pills.push({
                type: StatisticsGroups.TeamLineups,
                Component: TeamLineupsButton,
            });
        }

		if (playerStatisticsStore.isPlayerStatsAvailable) {
			pills.push({
				type: StatisticsGroups.PlayerStats,
				Component: PlayerStatisticsButton,
			});
		}

		if (sportStatisticsStore.isEventInsightsAvailable) {
			pills.push({
				type: StatisticsGroups.EventInsights,
				Component: EventInsightsButton,
			});
		}

		if (teamStandingsStatsStore.isTeamStandingsStatsAvailable) {           
			pills.push({
				type: StatisticsGroups.TeamStandings,
				Component: TeamStandingsButton,
			});
        }

		if (sportStatisticsStore.isFullStatsAvailable) {
			pills.push({
				type: StatisticsGroups.FullStats,
				Component: FullStatisticsButton,
			});
		}

		return pills;
	})();

	return (
		<div className="tabs tabs--boxed tabs--scroll--full scrollbar--custom">
			<SwiperWrapper type={SwiperType.SHOW_FIRST}>
				{statisticsPills.map((pill, index) => (
					<SwiperWrapper.SliderItem
						key={index}
						isActive={store.displayStatisticsGroup === pill.type}
						tabIndex={index}
					>
						<pill.Component store={store} />
					</SwiperWrapper.SliderItem>
				))}
			</SwiperWrapper>
		</div>
	);
});
